/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (
    typeof actions?.updateCart?.configure !== 'function' ||
    typeof actions?.openCart?.configure !== 'function'
  ) return false;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = window.Theme?.routes?.cart_url || '/cart';
      }
    },
  });
  return true;
}

// Retry once at DOM readiness if the actions API was not fully initialized.
if (!init()) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    window.addEventListener('load', init, { once: true });
  }
}
